import { getStage } from "./context";

export const showContractAddendum = getStage() !== "prod";
export const showCostAnalysis = getStage() !== "prod";
